import React, { Component, Fragment } from 'react'
import ReactTable from 'react-table'
import { filterCaseInsensitive } from '../util'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Icon, Popconfirm } from 'antd'

class VehiclesScheduledDeliveries extends Component {
  render() {
    const { scheduledDeliveries } = this.props
    return (
      <Fragment>
        <br />
        <h4>Scheduled Deliveries</h4>
        <ReactTable
          data={scheduledDeliveries}
          filterable
          defaultFilterMethod={filterCaseInsensitive}
          columns={[
            {
              columns: [
                {
                  Header: 'Driver name',
                  id: 'driver_name',
                  accessor: d => `${d.driver_first_name} ${d.driver_last_name}`
                },
                {
                  Header: 'Scheduled Date',
                  id: 'scheduled_date',
                  accessor: 'scheduled_date',
                  Cell: row => <span>{moment.utc(row.value).format('M/D/YYYY')}</span>,
                  minWidth: 70
                },
                {
                  Header: 'Status',
                  Cell: row => {
                    return (
                      <Fragment>
                        <Link to={`/drivers/delivery/${row.original.id}`}>
                          <Icon type="edit" />
                        </Link>
                        <Popconfirm
                          title="Are you sure you want to delete this item"
                          onConfirm={() => this.props.deleteScheduledDelivery(row.original.id)}
                        >
                          <Icon type="delete" />
                        </Popconfirm>
                      </Fragment>
                    )
                  },
                  maxWidth: 100
                }
              ]
            }
          ]}
          defaultPageSize={5}
          className="-striped -highlight"
        />
      </Fragment>
    )
  }
}

export default VehiclesScheduledDeliveries



// WEBPACK FOOTER //
// ./src/components/VehiclesScheduledDeliveries.js